import request from './request';
import {
  SignInRequest,
  SignInResponse  
} from './@types/account';
import endpoints, { withAppId } from './endpoints';

const signin = async ({ username, password }: SignInRequest): Promise<SignInResponse> =>
  request({
    baseURL: process.env.REACT_APP_API_BASE_URL_SECURITY,
    url: withAppId(endpoints.account.signIn),
    method: 'POST',
    data: {
      email: username,
      password
    },
  });

const authenticationService = {
  signin
};

export default authenticationService;
